import { useTranslations } from "@/lib/static-intl";
import { useState } from "react";

const RfmSectionsTabs = ({ tabs, setNoteDetails }) => {
  const t = useTranslations("creator_service.create_note_media_upload");
  const [activeTab, setActiveTab] = useState(tabs[0].label);

  const handleTabClick = (label) => {
    setNoteDetails((prev) => ({
      ...prev,
      media: [],
    }));
    setActiveTab(label);
  };

  return (
    <div className="w-full h-full flex flex-col pt-3 gap-3 md:gap-initial">
      <div className="w-full flex items-center gap-2 px-8">
        {tabs.map((tab, i) => (
          <button
            key={i}
            onClick={() => handleTabClick(tab.label)}
            className={`py-1 px-2 md:py-2 md:px-4 focus:outline-none font-semibold text-sm md:text-base ${
              activeTab === tab.label
                ? "border-b-2 border-red text-red"
                : "text-gray-500"
            }`}
          >
            {t(tab.label)}
          </button>
        ))}
      </div>
      {tabs.map((tab, i) => (
        <div
          key={i}
          className={`${
            activeTab === tab.label ? "block" : "hidden"
          } h-full w-full`}
        >
          {tab.content}
        </div>
      ))}
    </div>
  );
};

export default RfmSectionsTabs;
